<template>
  <div v-if="loading" class="loading">
    <div class="loading-item">
      <font-awesome-icon icon="spinner" size="3x" spin></font-awesome-icon>
      <span class="title"
        >Olá, é a sua primeira vez aqui? <br />
        Por favor aguarde, estamos carregando as informações de receitas para
        você.</span
      >
    </div>
  </div>
  <div v-else class="row receitas">
    <public-header :title="'Receita e Despesas'">
      <ano-base class="margem-bottom" />
      <div class="col-xs-12">
        <p>
          Aqui você encontra um resumo das receitas e despesas gerenciadas pela
          Prefeitura Municipal de Santos.
        </p>
        <p>
          Para o ano de
          <span class="destaque-header">{{ ano_base }}</span
          >, foi orçada uma receita total no valor de
          <span class="destaque-header">{{
            formatarMoeda(orcamentoAtual)
          }}</span
          >, com uma previsão de gastos no valor de
          <span class="destaque-header">
            {{ formatarMoeda(despesaAnualPrevista.atual) }}.
          </span>
        </p>
        <p>
          Até a presente data, houve uma arrecadação no valor de
          <span class="destaque-header">
            {{ formatarMoeda(receitaAtual) }}
          </span>
          e um total de
          <span class="destaque-header">
            {{ formatarMoeda(despesaAnualPaga.atual) }}
          </span>
          em despesas pagas.
        </p>
      </div>
      <div class="col-sm-6">
        <bar-chart
          ref="orcada_empenhada"
          :chart-data="graficoOrcadaEmpenhada"
          :gradiente="false"
          :coloredLine="true"
          :options="{
            ...chart_option,
            title: {
              display: true,
              text: 'Receita orçada x Despesa Empenhada',
              fontColor: '#C1D1C1'
            }
          }"
        ></bar-chart>
      </div>
      <div class="col-sm-6">
        <bar-chart
          ref="arrecadada_paga"
          :chart-data="graficoArrecadadaPaga"
          :gradiente="false"
          :coloredLine="true"
          :options="{
            ...chart_option,
            title: {
              display: true,
              text: 'Receita arrecadada x Despesa paga',
              fontColor: '#C1D1C1'
            }
          }"
        ></bar-chart>
      </div>
    </public-header>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li><router-link :to="'/'">Início</router-link></li>
          <li class="">Receitas e Despesas</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h2>Para mais informações</h2>
          <p>
            Abaixo, você poderá consultar um resumo de todas as receitas
            correntes e de capital administradas pela Prefeitura Municipal de
            Santos, o acompanhamento mensal e poderá navegar através dos
            diferentes níveis de informação.
          </p>
          <p>
            Poderá consultar também o resumo das despesas efetuadas pela
            prefeitura, a previsão de gastos, os valores empenhados, liquidados
            e pagos mensalmente, o total de gastos agrupado por unidade
            executora da despesa, pelas diferentes áreas (segurança pública,
            educação, etc.), além do detalhamento de cada despesa uma das
            despesas.
          </p>
          <div class="button-group">
            <router-link
              tag="button"
              :to="{ name: 'receitas' }"
              class="btn btn-primary"
              >Receitas</router-link
            >
            <router-link
              tag="button"
              :to="{ name: 'despesas' }"
              class="btn btn-primary"
              >Despesas</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { PublicHeader, BarChart, AnoBase } from '../../../components/common'
import { formatarMoeda, mesesAbr } from '../../../utils'
import colors from '../../../utils/colors'

export default {
  components: {
    PublicHeader,
    BarChart,
    AnoBase
  },
  data: () => ({
    // ano_base: new Date().getFullYear(),
    chart_base: { labels: mesesAbr, datasets: [{ label: '', data: [] }] },
    chart_option: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          fontColor: '#C1D1C1'
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 50,
              fontColor: '#C1D1C1',
              callback: function(value, index, values) {
                return value.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                })
              }
            }
          }
        ],
        xAxes: [
          {
            maxBarThickness: 50,
            ticks: {
              fontColor: '#C1D1C1'
            }
          }
        ]
      },
      tooltips: {
        callbacks: {
          label: function(tooltip, dataset) {
            var xLabel = dataset.datasets[tooltip.datasetIndex].label
            var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })
            return xLabel + ': ' + yLabel
          }
        }
      }
    }
  }),
  methods: {
    formatarMoeda,
    filtrarPorCodigo(codigo) {
      const { receitas_proprias } = this.$store.state.receitas_despesas

      const filterByID = obj => {
        if ('cd_plano_conta_rel' in obj && obj.cd_plano_conta_rel === codigo) {
          return true
        } else {
          return false
        }
      }

      const atual = { ...receitas_proprias.filter(filterByID) }

      return { atual: atual[0] }
    },
    retornaSomaPorKey(key) {
      const { detalhamento_despesas } = this.$store.state.receitas_despesas

      const reducer = (acumulador, atual) => {
        return acumulador + atual[key]
      }

      let resultAtual = detalhamento_despesas.reduce(reducer, 0)

      return {
        atual: resultAtual
      }
    },
    retornaAtualPorKey(key) {
      const { detalhamento_despesas } = this.$store.state.receitas_despesas

      const reducer = (acumulador, atual) => {
        return acumulador + atual[key]
      }

      let resultAtual = detalhamento_despesas.reduce(reducer, 0)

      return resultAtual
    }
  },
  computed: {
    ...mapState({
      ano_base: state => state.receitas_despesas.ano_base
    }),
    loading() {
      return this.receitas.length === 0
    },
    receitas() {
      return this.$store.state.receitas_despesas.receitas_proprias
    },
    graficoOrcadaEmpenhada() {
      const receita_corrente = this.filtrarPorCodigo('1').atual
      const receita_capital = this.filtrarPorCodigo('2').atual

      const previsto =
        Number(receita_corrente.vl_atualizado_f) +
        Number(receita_capital.vl_atualizado_f)

      const data = []

      for (let index = 0; index < mesesAbr.length; index++) {
        const element = mesesAbr[index].toLowerCase()

        if (
          receita_corrente[`vl_${element}_f`] === '0' &&
          receita_capital[`vl_${element}_f`] === '0'
        ) {
          break
        }

        data.push(
          (data[index - 1] || 0) + this.retornaAtualPorKey(`vl_${element}_emp`)
        )
      }

      const datasets = [
        {
          type: 'line',
          label: 'Receita Orçada',
          data: Array(12).fill(previsto),
          fill: false,
          borderColor: colors.coresRGB[0],
          backgroundColor: colors.coresRGB[0]
        },
        {
          label: 'Despesa Empenhada',
          data,
          backgroundColor: colors.coresRGB[1]
        }
      ]
      return {
        ...this.chart_base,
        datasets
      }
    },
    graficoArrecadadaPaga() {
      const dadosCorrente = this.filtrarPorCodigo('1')
      const dadosCapital = this.filtrarPorCodigo('2')
      const data = [],
        pagamentos = []

      for (let index = 0; index < mesesAbr.length; index++) {
        const element = mesesAbr[index].toLowerCase()

        if (
          dadosCorrente.atual[`vl_${element}_f`] === '0' &&
          dadosCapital.atual[`vl_${element}_f`] === '0'
        ) {
          break
        }

        pagamentos.push(
          (pagamentos[index - 1] || 0) +
            this.retornaAtualPorKey(`vl_${element}_pag`)
        )

        const soma =
          Number(dadosCorrente.atual[`vl_${element}_f`]) +
          Number(dadosCapital.atual[`vl_${element}_f`])
        data.push((data[index - 1] || 0) + soma)
      }

      const datasets = [
        {
          label: 'Receita Arrecadada',
          data,
          borderColor: colors.coresRGB[0]
        },
        {
          label: 'Despesa Paga',
          data: pagamentos,
          backgroundColor: colors.coresRGB[1]
        }
      ]
      return {
        ...this.chart_base,
        datasets
      }
    },
    orcamentoAtual() {
      const { loading, formatarMoeda, filtrarPorCodigo } = this

      if (loading) {
        return formatarMoeda(0)
      }

      const receitaCorrente = filtrarPorCodigo('1').atual.vl_atualizado_f
      const receitaCapital = filtrarPorCodigo('2').atual.vl_atualizado_f

      return Number(receitaCorrente) + Number(receitaCapital)
    },
    receitaAtual() {
      const { loading, formatarMoeda, filtrarPorCodigo } = this

      if (loading) {
        return formatarMoeda(0)
      }

      const receitaCorrente = filtrarPorCodigo('1').atual.vl_total_f
      const receitaCapital = filtrarPorCodigo('2').atual.vl_total_f

      return Number(receitaCorrente) + Number(receitaCapital)
    },
    despesaAnualPrevista() {
      return this.retornaSomaPorKey('vl_previsto')
    },
    despesaAnualPaga() {
      return this.retornaSomaPorKey('vl_total_pag')
    }
  }
}
</script>

<style scoped>
div.loading {
  min-height: 65vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

div.loading-item {
  display: block;
  text-align: center;
}

div.loading span.title {
  display: block;
  font-size: 1.7em;
}

.button-group {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.button-group button {
  height: 80px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/public/receitas_despesas/index.vue